<!-- Tile deletion confirmation -->
<p-confirmDialog key="deleteTile" header="{{ 'delete_group_confirm_header' | translate }}" class="tile-deletion-confirm" #deleteTileDialog>
    <ng-template pTemplate="icon">
        <i class="pi pi-exclamation-triangle text-yellow-500"></i>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="w-full">
            <div class="flex items-center justify-start mb-8 w-full">
                <p-message severity="warn" class="w-full">
                    {{ "irreversible_action" | translate }}
                </p-message>
            </div>
            <div class="flex items-center justify-end">
                <button type="button" pButton severity="secondary" (click)="onCancel()" class="p-button-text mr-2">
                    {{ "button_cancel" | translate }}
                </button>
                <button type="button" pButton severity="danger" (click)="deleteTile()">
                    {{ "button_delete" | translate }}
                </button>
            </div>
        </div>
    </ng-template>
</p-confirmDialog>
<p-confirmDialog key="archiveTile" icon="pi pi-exclamation-triangle" class="archiveConfirm"> </p-confirmDialog>

<!-- Bulk selection: select all -->
<p-popover #confirmPanel [dismissable]="false" appendTo="body" [style]="{ width: '300px' }">
    <div class="flex items-center" style="display: flex; align-items: center; gap: 0.5rem; padding: 10px">
        <span>{{ "bulk_tile_selection_label" | translate: { totalCount: filteredTiles.length, layerName: layerName } }}</span>
    </div>
    <div class="flex justify-end gap-4" style="padding-top: 10px">
        <button type="button" pButton (click)="onCancel()" class="p-button-text">
            {{ "standard_no" | translate }}
        </button>
        <button type="button" pButton severity="primary" (click)="confirmBulkSelection(confirmPanel)" class="p-button-outlined">
            {{ "standard_yes" | translate }}
        </button>
    </div>
</p-popover>

<p-popover #menuPanel [dismissable]="true" appendTo="body">
    <div style="display: flex; flex-direction: column; gap: 0.5rem">
        <!-- Fav button -->
        <button
            data-testid="tile-bulk-favorite"
            pButton
            type="button"
            [disabled]="selectedTiles.size === 0"
            (click)="onFavoriteClicked()"
            class="p-button-text w-full flex justify-start! text-left"
            [label]="areAllSelTilesFav ? ('tiles_remove_favorite_label' | translate) : ('tiles_add_favorite_label' | translate)"
        >
            <i class="pi pi-fw" [ngClass]="areAllSelTilesFav ? 'pi-star' : 'pi-star-fill'" style="margin-right: 0.5rem"></i>
        </button>
        <!-- Archive btn -->
        <button
            data-testid="tile-bulk-archive"
            pButton
            type="button"
            [disabled]="selectedTiles.size === 0 || !isPro"
            pTooltip="{{ (!isPro ? 'tooltip_billed_button' : '') | translate }}"
            tooltipPosition="top"
            (click)="onBulkSelectionArchiveOrRestore()"
            class="p-button-text w-full flex justify-start! text-left"
        >
            <i class="pi pi-fw pi-inbox" style="margin-right: 0.5rem"></i> {{ showArchived ? ("tiles_restore" | translate) : ("tiles_archive" | translate) }}
        </button>
        <!-- Menu Item: Delete -->
        @if (selectedTileStatus && isAdminOrManager) {
            <button
                data-testid="tile-bulk-delete"
                pButton
                type="button"
                [pTooltip]="tilesHaveActivities ? ('bulk_tile_deletion_block' | translate: { layerName: layerName }) : null"
                [disabled]="selectedTiles.size === 0 || tilesHaveActivities"
                (click)="deleteBulkConfirm()"
                class="p-button-text w-full flex justify-start! text-left text-red-700!"
            >
                <i class="pi pi-fw pi-trash" style="margin-right: 0.5rem"></i> {{ "activities_multidelete" | translate }}
            </button>
        }
    </div>
</p-popover>

@if (loadingState === 2) {
    <div class="card">
        <div class="p-fluid">
            <p-table
                data-testid="tile-table"
                [value]="filteredTiles"
                responsiveLayout="scroll"
                dataKey="id"
                selectionMode="single"
                [(selection)]="selectedTile"
                (onRowSelect)="onRowSelect($event)"
                [paginator]="true"
                [rows]="paginationRows"
                [rowsPerPageOptions]="[10, 25, 50, 100, 250]"
                [showCurrentPageReport]="true"
                (onPage)="onPageChange($event)"
                currentPageReportTemplate="{{ 'table_pagination_showing' | translate }} {first} {{ 'table_pagination_to' | translate }} {last} {{
                    'table_pagination_of' | translate
                }} {totalRecords} {{ 'table_pagination_entries' | translate }}"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-between gap-2">
                        <!-- justify-content-end justify-content-between -->
                        <div class="flex items-center gap-2">
                            @if (currentUser?.hasPermissionStr("TILE_ARCHIVE")) {
                                <div class="mr-4">
                                    <p-select
                                        data-testid="tile-status"
                                        [options]="tileStatusOptions"
                                        [(ngModel)]="selectedTileStatus"
                                        (onChange)="toggleTileStatus()"
                                        placeholder="Select Status"
                                        class="tile-status-dropdown"
                                    />
                                </div>
                            }
                        </div>
                        <div class="flex items-center gap-2">
                            <div>
                                <p-menu [popup]="true" [model]="actionMenu" appendTo="body"></p-menu>
                                @if (selectedTiles.size > 0) {
                                    <button
                                        data-testid="bulk-edit-tiles"
                                        type="button"
                                        pButton
                                        icon="pi pi-chevron-down"
                                        iconPos="right"
                                        class="p-button-text"
                                        label="{{ 'edit_bulk_tiles' | translate: { selectedTilesCount: selectedTiles.size, layerName: layerName } }}"
                                        (click)="openBulkEditPanel($event)"
                                        style="width: inherit"
                                    ></button>
                                }
                            </div>
                            @if (isAdminOrManager) {
                                <div>
                                    <app-dropdown-panel
                                        [labels]="importOptions.labels"
                                        [classes]="importOptions.classes"
                                        [icons]="importOptions.icons"
                                        [functions]="importOptions.functions"
                                        [disabled]="importOptions.disabled"
                                        [tooltips]="importOptions.tooltips"
                                        [tooltipLinks]="importOptions.tooltipLinks"
                                        [tooltipLinkLabels]="importOptions.tooltipLinkLabels"
                                        [tooltipAutoHide]="importOptions.tooltipAutoHide"
                                        [buttonClasses]="['p-button-text', 'p-button-secondary']"
                                        buttonLabel="{{ 'standard_import_action' | translate }}"
                                        buttonIcon="pi pi-chevron-down"
                                    />
                                </div>
                            }
                            <div>
                                @if (currentUser?.hasPermissionStr("TILE_CREATE")) {
                                    <button
                                        data-testid="add-tile"
                                        style="width: auto"
                                        pButton
                                        type="button"
                                        (click)="showAddDialog()"
                                        label="{{ 'tiles_add' | translate: { layerName: layerName } }}"
                                        icon="pi pi-plus"
                                        class=""
                                    ></button>
                                }
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 4rem"></th>
                        <th data-testid="tile-sort-favorite" style="width: 3rem" pSortableColumn="favorite">
                            <p-sortIcon field="favorite"></p-sortIcon>
                        </th>
                        <th style="width: 3rem"></th>
                        <th data-testid="tile-sort-name" pSortableColumn="name">
                            {{ "tiles_name" | translate }}
                            <p-sortIcon field="name"></p-sortIcon>
                        </th>
                        <th data-testid="tile-sort-description" pSortableColumn="description">
                            {{ "tiles_description" | translate }}
                            <p-sortIcon field="description"> </p-sortIcon>
                        </th>
                        @if (!isFirstLayer) {
                            <th data-testid="tile-sort-parent" pSortableColumn="parentSort">
                                {{ "tiles_assigned" | translate: { parentLayerName: parentLayerName } }}
                                <p-sortIcon field="parentSort"></p-sortIcon>
                            </th>
                        }
                        @if (isAdminOrManager && !isSingleUser) {
                            <th>{{ "tile_assignments_header" | translate }}</th>
                        }
                        @if (showTimeBudgets()) {
                            <th data-testid="tile-header-time-budget">{{ "time_budget_label" | translate }}</th>
                        }
                    </tr>
                    <tr>
                        <th style="width: 4rem">
                            <p-checkbox
                                data-testid="tile-select-all"
                                [binary]="true"
                                [(ngModel)]="areAllTilesSelected"
                                (onChange)="selectAll($event.checked, $event.originalEvent)"
                            />
                        </th>
                        <th style="width: 3rem"></th>
                        <th style="width: 3rem"></th>
                        <th style="max-width: 60rem">
                            <p-columnFilter data-testid="tile-filter-name" type="text" field="name" matchMode="contains"></p-columnFilter>
                        </th>
                        <th>
                            <p-columnFilter data-testid="tile-filter-description" type="text" field="description" matchMode="contains"></p-columnFilter>
                        </th>
                        @if (!isFirstLayer) {
                            <th style="max-width: 86rem">
                                <p-columnFilter field="parents" matchMode="in" [showMenu]="false">
                                    <ng-template pTemplate="filter">
                                        <p-multiSelect
                                            data-testid="tile-filter-parent"
                                            [options]="tileParents"
                                            placeholder="{{ 'standard_any' | translate }}"
                                            appendTo="body"
                                            (onChange)="filterByParent($event.value)"
                                            optionLabel="name"
                                            selectedItemsLabel="{0} {{ 'standard_items_selected' | translate }}"
                                        >
                                            <ng-template let-parent pTemplate="item">
                                                <div class="p-multiselect-parent-option">
                                                    <span class="ml-1">{{ parent.name }}</span>
                                                </div>
                                            </ng-template>
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                        }
                        @if (isAdminOrManager && !isSingleUser) {
                            <th style="max-width: 86rem">
                                <p-columnFilter data-testid="tile-filter-assignees" type="text" field="assignees" matchMode="contains"></p-columnFilter>
                            </th>
                        }
                        @if (showTimeBudgets()) {
                            <th></th>
                        }
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-tile>
                    <tr [pSelectableRow]="tile" [attr.data-testid]="'tile-row-' + tile.id">
                        <td style="cursor: default !important">
                            <p-checkbox
                                [attr.data-testid]="'tile-select-' + tile.id"
                                [binary]="true"
                                [value]="tile.isChecked"
                                [ngModel]="tile.isChecked"
                                (onChange)="select(tile, $event.checked); $event.originalEvent?.stopPropagation()"
                            >
                            </p-checkbox>
                        </td>
                        <td style="cursor: default !important">
                            <div class="center-wrapper" style="cursor: pointer">
                                <i class="pi {{ tile.favorite ? 'pi-star-fill' : 'pi-star' }}" style="color: var(--primary-color)"></i>
                            </div>
                        </td>
                        <td>
                            <div class="center-wrapper">
                                <div [style.background-color]="tile.color" [style.border]="getBoarder(tile)" class="circle"></div>
                            </div>
                        </td>
                        <td style="max-width: 60rem" [attr.data-testid]="'tile-name-' + tile.id">
                            @if (tile.externalRefs) {
                                {{ truncateText(tile.name, 150) }}
                                <app-external-refs [externalRefs]="tile.externalRefs" />
                            } @else {
                                {{ truncateText(tile.name, 170) }}
                            }
                        </td>
                        <td [attr.data-testid]="'tile-description-' + tile.id">
                            {{ tile.description }}
                        </td>
                        @if (!isFirstLayer) {
                            <td style="max-width: 86rem">
                                @if (tile.type === TileType.Global) {
                                    <div class="flex items-center">
                                        <i class="pi pi-globe mr-2" [style.color]="tile.type === 'Global' ? '#6c757d' : ''"></i>
                                        <span class="text">{{ "tile_global_label" | translate: { layerName: parentLayerName } }}</span>
                                    </div>
                                } @else {
                                    {{ getParentsFromTile(tile) }}
                                }
                            </td>
                        }
                        @if (isAdminOrManager && !isSingleUser) {
                            @if (!tile.isAvailableToAllUsers) {
                                @if (tile.assignedGroups.length > 0 || tile.assignedUsers.length > 0) {
                                    <td style="max-width: 86rem; text-align: left">
                                        @if (tile.assignedGroups.length > 0) {
                                            <span>
                                                @for (group of tile.assignedGroups; track group; let last = $last) {
                                                    <p-chip icon="pi pi-users" label="{{ group.name }}"></p-chip>
                                                    {{ !last ? ", " : "" }}
                                                }
                                            </span>
                                        }
                                        @if (tile.assignedUsers.length > 0) {
                                            <span>
                                                @for (user of tile.assignedUsers; track user; let last = $last) {
                                                    {{ getUserDisplayName(user) + (!last ? ", " : "") }}
                                                }
                                            </span>
                                        }
                                    </td>
                                } @else {
                                    <td class="table-cell">
                                        <!-- <i class="pi pi-users icon"></i> -->
                                        <span class="text">{{ "private_but_not_assigned" | translate }}</span>
                                    </td>
                                }
                            } @else {
                                <td class="table-cell">
                                    <i class="pi pi-users icon"></i>
                                    <span class="text">{{ "tile_public_label" | translate }}</span>
                                </td>
                            }
                        }
                        @if (showTimeBudgets()) {
                            <td [attr.data-testid]="'tile-time-budget-' + tile.id">
                                @let budgetView = timeBudgetViews.get(tile.id);
                                @if (budgetView) {
                                    <app-time-budget-bar [usedSeconds]="budgetView.usedSeconds" [budgetSeconds]="budgetView.budget.budgetSeconds" />
                                }
                            </td>
                        }
                    </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft"> </ng-template>
                <ng-template pTemplate="paginatorright"> </ng-template>
            </p-table>
        </div>
    </div>
}

@if (loadingState === 1) {
    <div class="mb-16 flex justify-center">
        <div class="mt-20">
            <div class="text-center items-center">
                <div class="mt-1">
                    <img class="inline" [src]="getImageUrl() | safe: 'resourceUrl'" width="65%" height="65%" alt="No data" />
                </div>
                <div class="mb-6">
                    <h4>{{ "tiles_nodata_title" | translate: { layerName: layerName } }}</h4>
                    <p [innerHTML]="getNoDataLayerText() | translate: { layerName: layerName, parentLayerName: getLayerName() }"></p>
                </div>
                <div class="mb-16 flex justify-center">
                    @if (isAdminOrManager) {
                        <div class="mr-6">
                            <app-dropdown-panel
                                [labels]="importOptions.labels"
                                [classes]="importOptions.classes"
                                [icons]="importOptions.icons"
                                [functions]="importOptions.functions"
                                [disabled]="importOptions.disabled"
                                [tooltips]="importOptions.tooltips"
                                [tooltipLinks]="importOptions.tooltipLinks"
                                [tooltipLinkLabels]="importOptions.tooltipLinkLabels"
                                [tooltipAutoHide]="importOptions.tooltipAutoHide"
                                [buttonClasses]="['p-button-text', 'p-button-secondary']"
                                buttonLabel="{{ 'standard_import_action' | translate }}"
                                buttonIcon="pi pi-chevron-down"
                            />
                        </div>
                    }
                    <p-button
                        data-testid="add-tile"
                        (click)="showAddDialog()"
                        label="{{ 'tiles_nodata_button_text' | translate: { layerName: layerName } }}"
                        icon="pi pi-plus"
                        class="icon-button-fix"
                    />
                </div>

                <div>
                    <p class="mt-16 mb-12">
                        <label style="color: #818181">{{ "tiles_nodata_text2" | translate }} </label>
                        <a [routerLink]="['/settings/layers']">{{ "tiles_nodata_text3" | translate }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
}

<app-tile-edit-dialog
    [showAddEditDialog]="showAddEditDialog"
    [tile]="tileToEdit"
    [isPro]="isPro"
    [showArchived]="showArchived"
    [layerName]="layerName"
    [layerId]="layerId"
    [layerIndex]="getLayerIndex()"
    [parentLayerName]="parentLayerName"
    [hasParent]="hasParent"
    [tileParents]="tileParents"
    (onTileChanged)="onTileChanged($event)"
    (onTileAdded)="onTileAdded($event)"
    (onTileDeleted)="onTileDeleted($event)"
    (onTimeBudgetChanged)="onTimeBudgetChanged($event)"
    (onClose)="onTileDialogClose()"
></app-tile-edit-dialog>

@for (integration of activeIntegrations; track integration.service) {
    <app-integration-import
        [serviceIdentifier]="integration.service"
        [(showDialog)]="showImportModalMap[integration.service]"
        [allTiles]="allTilesOfLayer ?? []"
        (import)="onImportSuccess()"
        [layers]="layers"
        [currentLayerName]="layerName"
    />
}
